import React from 'react'
import Sidebar from '../components/mainpage/subcomponent/Sidebar'
import '../components/styles/dashboard.css'
import ContractIn from '../components/mainpage/subcomponent/contractIn'
const MainContractIn = () => {
    return (
        <div>
            <Sidebar />
            <div className='container-fluid'>
                <ContractIn />
            </div>
        </div>
    )
}

export default MainContractIn